import { StyledIconButton } from "./styles";

type ColumnsSelectionButtonProps = {
    isDisabled?: boolean;
    onClick(): void;
};

const ColumnsSelectionButton = ({ isDisabled = false, onClick }: ColumnsSelectionButtonProps) => {
    return (
        <StyledIconButton
            type="flat"
            iconSize="sm"
            iconName="columnPicker"
            dataAutomation="columns-selection-trigger-button"
            isDisabled={isDisabled}
            onClick={onClick}
        />
    );
};

export default ColumnsSelectionButton;
